import Vue from 'vue'
import { REMOTE_PATHS } from '../constants/remotePaths.constant'
import { api } from '../api'
import ProtoBuilder from '../services/proto.service'

const state = {
  socket: null,
  protoBuilder: new ProtoBuilder(),
  calling: null,
  callId: null,
  userId: null,
  deviceId: null,
  isCaller: null,
  accessToken: null,
  videoCall: null,
  peerId: null,
  sequence: 0,
  callerUserId: null,
  turnOffWindow: false,
  secondUserData: null,
  activeVideo: false,
  // firstTime: false,
  mainUserData: null,
  callStatus: '',
}

const actions = {
  async connectWebsocket({ state, dispatch, commit }) {
    if (state.socket) {
      state.socket = null
    }
    const authToken = await api
      .getWebRtcToken({ token: state.accessToken })
      .then(({ data }) => {
        return data.token
      })
    state.socket = new WebSocket(
      `${REMOTE_PATHS.CALL_WS_PATH}?auth-token=${authToken}&device-id=${state.deviceId}`
    )
    state.socket.binaryType = 'arraybuffer'
    state.socket.onopen = e => {
      console.log('Socket Connected')
      // dispatch('ping')
      // dispatch('setPeerConnection', e)
    }
    state.socket.onmessage = event => {
      dispatch('onMessageReceive', event)
    }
    state.socket.onclose = event => {
      console.warn('Socket Closed')
      commit('stoppedCall')
      // if (event.code !== 1000) {
      // dispatch('closeConference')
      // state.socket = null
      // }
    }
  },
  onMessageReceive({ state, dispatch, commit }, message) {
    const decodedMessage = state.protoBuilder.decode(
      { data: message.data },
      'ServerContainerMessage'
    )
    switch (decodedMessage.data) {
      case 'pong':
        break
      case 'startedCall':
        dispatch('startedCall', decodedMessage)
        console.log('startedCall')
        break
      case 'startCallError':
        console.log('startCallError')
        break
      case 'awaitingCall':
        console.log('awaitingCall')
        dispatch('onAwaitingCall', decodedMessage)
        break
      case 'answerCallError':
        console.log('answerCallError')
        break
      case 'stoppedCall':
        console.log('stoppedCall')
        commit('stoppedCall')
        break
      case 'receiveMessage':
        const data = decodedMessage.receiveMessage.data
        const dataType = data.data
        switch (dataType) {
          case 'iceCandidateAdd':
            const iceCandidateAdd = data.iceCandidateAdd
            dispatch('onIceCandidateAdd', iceCandidateAdd)
            break
          case 'iceCandidateRemoved':
            const iceCandidateRemoved = data.iceCandidateRemoved
            dispatch('onIceCandidateRemoved', iceCandidateRemoved)
            break
          case 'sessionsDescription':
            if (state.firstTime && !state.isCaller) {
              state.activeVideo = !state.activeVideo
            } else {
              state.firstTime = !state.firstTime
            }
            const sessionsDescription = data.sessionsDescription
            dispatch('onSessionsDescription', sessionsDescription)
            break
          case 'answererRequestRenegotiation':
            commit('changeScene')
            break
          case 'onRenegotiationNeeded':
            console.log('onRenegotiationNeeded')
            break
        }
        break
      case 'authorizationFinished':
        if (state.isCaller) {
          dispatch('startCall')
        }
        break
      case 'participantReceivedAwaitingCall':
        commit('changeStatus', { status: 'Ringing' })
        console.log('participantReceivedAwaitingCall')
        break
      default:
        return decodedMessage
    }
  },
  startCall({ state }) {
    const startCallClientMessage = state.protoBuilder.encode(
      {
        data: {
          startCall: {
            participantUserId: convertStringToBytes(state.peerId),
            onlyAudio: !state.videoCall,
            callId: convertStringToBytes(state.callId),
          },
        },
      },
      'ClientConainerMessage'
    )
    state.socket.send(startCallClientMessage)
  },
  onAwaitingCall({ state, dispatch, commit }, message) {
    const awaitingCall = message.awaitingCall
    commit('setCallId', { callId: awaitingCall.callId })
    commit('setCallerUserId', { callerUserId: awaitingCall.callerUserId })
    // dispatch('getUserData')
    dispatch('start', { iceServers: awaitingCall.iceServers, isCaller: false })

    const answerMessage = state.protoBuilder.encode(
      {
        data: {
          answerCall: {
            callId: convertStringToBytes(state.callId),
          },
        },
      },
      'ClientConainerMessage'
    )
    state.socket.send(answerMessage)
  },
  startedCall({ state, dispatch, commit }, message) {
    commit('changeStatus', { status: 'Connecting' })
    const startedCallData = message.startedCall
    dispatch('start', {
      iceServers: startedCallData.iceServers,
      isCaller: true,
    })
  },
  async getUserData({ state, commit }) {
    const secondUserData = await api
      .getUserInfo({ userId: state.peerId })
      .then(({ data }) => {
        return state.protoBuilder.decode({ data }, 'UserResponse')
      })

    commit('assignCallerData', secondUserData)
  },
  async getMainUserData({ state, commit }) {
    const mainUserData = await api
      .getUserInfo({ userId: state.userId })
      .then(({ data }) => {
        return state.protoBuilder.decode({ data }, 'UserResponse')
      })

    commit('assignMainUserData', mainUserData)
  },
  sendIceCandidate({ state }, { candidate }) {
    if (candidate != null) {
      const DataMessage = state.protoBuilder.lookup('DataMessage')
      const IceCandidate = state.protoBuilder.lookup('DataMessage.IceCandidate')
      const IceCandidateAdd = state.protoBuilder.lookup(
        'DataMessage.IceCandidateAdd'
      )
      const iceCandidateMessage = state.protoBuilder.encode(
        {
          data: {
            sendMessage: {
              callId: convertStringToBytes(state.callId),
              sequence: state.sequence++,
              data: DataMessage.create({
                iceCandidateAdd: IceCandidateAdd.create({
                  iceCandidate: [
                    IceCandidate.create({
                      sdpMid: candidate.sdpMid,
                      sdpMLineIndex: candidate.sdpMLineIndex,
                      sdp: candidate.candidate,
                    }),
                  ],
                }),
              }),
            },
          },
        },
        'ClientConainerMessage'
      )

      state.socket.send(iceCandidateMessage)
    }
  },
  sendSessionsDescription({ state }, { description, type }) {
    const DataMessage = state.protoBuilder.lookup('DataMessage')
    const sessionsDescriptionMessage = state.protoBuilder.encode(
      {
        data: {
          sendMessage: {
            callId: convertStringToBytes(state.callId),
            sequence: state.sequence++,
            data: DataMessage.create({
              sessionsDescription: {
                type: type,
                description: description.sdp,
              },
            }),
          },
        },
      },
      'ClientConainerMessage'
    )
    state.socket.send(sessionsDescriptionMessage)
  },

  sendRenegotiation({ state }) {
    const DataMessage = state.protoBuilder.lookup('DataMessage')
    const renegotiationData = state.protoBuilder.encode(
      {
        data: {
          sendMessage: {
            callId: convertStringToBytes(state.callId),
            sequence: state.sequence++,
            data: DataMessage.create({
              answererRequestRenegotiation: {},
            }),
          },
        },
      },
      'ClientConainerMessage'
    )
    state.socket.send(renegotiationData)
  },

  declineCall({ state, commit }) {
    commit('changeStatus', { status: '' })
    const stopCallMessage = state.protoBuilder.encode(
      {
        data: {
          stopCall: {
            callId: convertStringToBytes(state.callId),
            reasonCode: 1,
          },
        },
      },
      'ClientConainerMessage'
    )
    state.socket.send(stopCallMessage)
  },
  userOpinion({ state }, data) {
    const clientCallSummaryMessage = state.protoBuilder.encode(
      {
        data: {
          callId: convertStringToBytes(state.callId),
          username: state.mainUserData.user.name,
          userExperience: data.userExperience,
          appVersion: '16',
          // Todo
          avgCallQuality: 'todo',
          // Todo
          timeToRinging: 'todo',
          isInitiator: state.isCaller,
          deviceInfo: {
            os: data.deviceInfo.os,
            model: data.deviceInfo.model,
            platform: 'Web',
          },
          // Todo
          networkConnectionFrequency: 'todo',
          // Todo
          twilioQualityFrequency: 'todo',
        },
      },
      'CreateClientCallSummaryRequest'
    )
    api.userOpinions(clientCallSummaryMessage, state.accessToken)
  },
}
const mutations = {
  stoppedCall(state) {
    state.turnOffWindow = true
    state.callStatus = 'declineCall'
  },
  changeStatus(state, data) {
    state.callStatus = data.status
  },
  assignCallerData(state, data) {
    state.secondUserData = data
  },
  assignMainUserData(state, data) {
    state.mainUserData = data
  },
  changeScene(state) {
    state.activeVideo = !state.activeVideo
  },
  setInitialStore(
    state,
    { callId, deviceId, isCaller, accessToken, peerId, videoCall, userId }
  ) {
    Vue.set(state, 'callId', callId)
    Vue.set(state, 'deviceId', deviceId)
    Vue.set(state, 'isCaller', JSON.parse(isCaller))
    Vue.set(state, 'accessToken', accessToken)
    Vue.set(state, 'peerId', peerId)
    Vue.set(state, 'videoCall', JSON.parse(videoCall))
    Vue.set(state, 'userId', userId)
  },
  setCallId(state, { callId }) {
    state.callId = callId
  },
  setCallerUserId(state, { callerUserId }) {
    state.callerUserId = convertBinaryToStr(callerUserId)
  },
  statusVideo(state, { data }) {
    state.activeVideo = data
  },
}

export default {
  state,
  actions,
  mutations,
}

function convertBinaryToStr(array) {
  var out, i, len, c
  var char2, char3

  out = ''
  len = array.length
  i = 0
  while (i < len) {
    c = array[i++]
    switch (c >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        // 0xxxxxxx
        out += String.fromCharCode(c)
        break
      case 12:
      case 13:
        // 110x xxxx   10xx xxxx
        char2 = array[i++]
        out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f))
        break
      case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
        char2 = array[i++]
        char3 = array[i++]
        out += String.fromCharCode(
          ((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0)
        )
        break
    }
  }

  return out
}

function convertStringToBytes(str) {
  if (typeof str !== 'string') {
    return str
  }
  const utf8 = []
  for (let ii = 0; ii < str.length; ii++) {
    let charCode = str.charCodeAt(ii)
    if (charCode < 0x80) utf8.push(charCode)
    else if (charCode < 0x800) {
      utf8.push(0xc0 | (charCode >> 6), 0x80 | (charCode & 0x3f))
    } else if (charCode < 0xd800 || charCode >= 0xe000) {
      utf8.push(
        0xe0 | (charCode >> 12),
        0x80 | ((charCode >> 6) & 0x3f),
        0x80 | (charCode & 0x3f)
      )
    } else {
      ii++
      // Surrogate pair:
      // UTF-16 encodes 0x10000-0x10FFFF by subtracting 0x10000 and
      // splitting the 20 bits of 0x0-0xFFFFF into two halves
      charCode =
        0x10000 + (((charCode & 0x3ff) << 10) | (str.charCodeAt(ii) & 0x3ff))
      utf8.push(
        0xf0 | (charCode >> 18),
        0x80 | ((charCode >> 12) & 0x3f),
        0x80 | ((charCode >> 6) & 0x3f),
        0x80 | (charCode & 0x3f)
      )
    }
  }
  return utf8
}
